import { api } from '../consumerApiSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        postConsumerApplicationsV2Prequalifications: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/prequalifications`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2Prequalifications,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        postConsumerApplicationsV2PrequalificationsApplicationIdNextLender: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/prequalifications/${queryArg.applicationId}/next_lender`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2PrequalificationsApplicationIdNextLender,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV2PrequalificationsNew: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/prequalifications/new`,
                params: {
                    location_id: queryArg.locationId,
                    terms_language: queryArg.termsLanguage,
                },
            }),
        }),
        postConsumerApplicationsV2CreditApplicationsCreate: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/create`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2CreditApplicationsCreate,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        postConsumerApplicationsV2CreditApplicationsApplicationIdPrequalify: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}/prequalify`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2CreditApplicationsApplicationIdPrequalify,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV2CreditApplicationsApplicationIdLenderRequirements: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}/lender_requirements`,
            }),
        }),
        postConsumerApplicationsV2CreditApplicationsApplyAfterPrequalification: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/apply_after_prequalification`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2CreditApplicationsApplyAfterPrequalification,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        postConsumerApplicationsV2CreditApplicationsApplicationIdEdsEvents: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}/eds/events`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2CreditApplicationsApplicationIdEdsEvents,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        postConsumerApplicationsV2CreditApplicationsApplicationIdEdsVerify: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}/eds/verify`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2CreditApplicationsApplicationIdEdsVerify,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV2CreditApplicationsApplicationId: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}`,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        patchConsumerApplicationsV2CreditApplicationsApplicationId: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}`,
                method: 'PATCH',
                body: queryArg.patchConsumerApplicationsV2CreditApplicationsApplicationId,
            }),
        }),
        postConsumerApplicationsV2CreditApplicationsApplicationIdApproveChargeFlow: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}/approve_charge_flow`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2CreditApplicationsApplicationIdApproveChargeFlow,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV2CreditApplicationsLookupVerificationToken: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/lookup/${queryArg.verificationToken}`,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV2CreditApplicationsApplicationIdPaymentCalculator: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}/payment_calculator`,
                params: {
                    financed_amount: queryArg.financedAmount,
                    payment_frequency: queryArg.paymentFrequency,
                },
            }),
        }),
        getConsumerApplicationsV2CreditApplicationsTokenToken: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/token/${queryArg.token}`,
                params: {
                    ssn_last_four: queryArg.ssnLastFour,
                    date_of_birth: queryArg.dateOfBirth,
                    zip: queryArg.zip,
                },
            }),
        }),
        getConsumerApplicationsV2CreditApplicationsTokenTokenValidate: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/token/${queryArg.token}/validate`,
            }),
        }),
        getConsumerApplicationsV2CreditApplicationsStatusStatus: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/status/${queryArg.status}`,
                params: {
                    ssn_last_four: queryArg.ssnLastFour,
                    date_of_birth: queryArg.dateOfBirth,
                    zip: queryArg.zip,
                    terms_language: queryArg.termsLanguage,
                    location_id: queryArg.locationId,
                },
            }),
        }),
        postConsumerApplicationsV2CreditApplicationsApplicationIdIdentityVerification: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}/identity_verification`,
                method: 'POST',
            }),
        }),
        getConsumerApplicationsV2CreditApplicationsApplicationIdIdentityVerification: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}/identity_verification`,
            }),
        }),
        postConsumerApplicationsV2CreditApplicationsApplicationIdApply: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/credit_applications/${queryArg.applicationId}/apply`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2CreditApplicationsApplicationIdApply,
            }),
        }),
        getConsumerApplicationsV2ApproveChargeFlowsToken: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/approve_charge_flows/${queryArg.token}`,
                headers: {
                    Authorization: queryArg.authorization,
                },
                params: {
                    terms_language: queryArg.termsLanguage,
                },
            }),
        }),
        postConsumerApplicationsV2ApproveChargeFlowsApproveChargeFlowIdAccept: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/approve_charge_flows/${queryArg.approveChargeFlowId}/accept`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2ApproveChargeFlowsApproveChargeFlowIdAccept,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV2AccountFinderLookupVerificationToken: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/account_finder/lookup/${queryArg.verificationToken}`,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        postConsumerApplicationsV2OtpSend: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/otp/send`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2OtpSend,
            }),
        }),
        postConsumerApplicationsV2OtpVerify: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/otp/verify`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2OtpVerify,
            }),
        }),
        getConsumerApplicationsV2OtpBypassOtp: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/otp/bypass_otp`,
                params: {
                    sent_token: queryArg.sentToken,
                },
            }),
        }),
        getConsumerApplicationsV2TransactionsLookupVerificationToken: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/transactions/lookup/${queryArg.verificationToken}`,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        postConsumerApplicationsV2TransactionsSaleVerificationToken: build.mutation({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/transactions/sale/${queryArg.verificationToken}`,
                method: 'POST',
                body: queryArg.postConsumerApplicationsV2TransactionsSaleVerificationToken,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
        getConsumerApplicationsV2PlansVerificationToken: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/plans/${queryArg.verificationToken}`,
                headers: {
                    Authorization: queryArg.authorization,
                },
                params: {
                    location_id: queryArg.locationId,
                    amount: queryArg.amount,
                    consumer_credit_instrument_id: queryArg.consumerCreditInstrumentId,
                },
            }),
        }),
        getConsumerApplicationsV2FeatureFlagsGlobal: build.query({
            query: (queryArg) => ({
                url: `/consumer_applications/v2/feature_flags/global`,
                headers: {
                    Authorization: queryArg.authorization,
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as consumerApplicationsApi };
export const { usePostConsumerApplicationsV2PrequalificationsMutation, usePostConsumerApplicationsV2PrequalificationsApplicationIdNextLenderMutation, useGetConsumerApplicationsV2PrequalificationsNewQuery, useLazyGetConsumerApplicationsV2PrequalificationsNewQuery, usePostConsumerApplicationsV2CreditApplicationsCreateMutation, usePostConsumerApplicationsV2CreditApplicationsApplicationIdPrequalifyMutation, useGetConsumerApplicationsV2CreditApplicationsApplicationIdLenderRequirementsQuery, useLazyGetConsumerApplicationsV2CreditApplicationsApplicationIdLenderRequirementsQuery, usePostConsumerApplicationsV2CreditApplicationsApplyAfterPrequalificationMutation, usePostConsumerApplicationsV2CreditApplicationsApplicationIdEdsEventsMutation, usePostConsumerApplicationsV2CreditApplicationsApplicationIdEdsVerifyMutation, useGetConsumerApplicationsV2CreditApplicationsApplicationIdQuery, useLazyGetConsumerApplicationsV2CreditApplicationsApplicationIdQuery, usePatchConsumerApplicationsV2CreditApplicationsApplicationIdMutation, usePostConsumerApplicationsV2CreditApplicationsApplicationIdApproveChargeFlowMutation, useGetConsumerApplicationsV2CreditApplicationsLookupVerificationTokenQuery, useLazyGetConsumerApplicationsV2CreditApplicationsLookupVerificationTokenQuery, useGetConsumerApplicationsV2CreditApplicationsApplicationIdPaymentCalculatorQuery, useLazyGetConsumerApplicationsV2CreditApplicationsApplicationIdPaymentCalculatorQuery, useGetConsumerApplicationsV2CreditApplicationsTokenTokenQuery, useLazyGetConsumerApplicationsV2CreditApplicationsTokenTokenQuery, useGetConsumerApplicationsV2CreditApplicationsTokenTokenValidateQuery, useLazyGetConsumerApplicationsV2CreditApplicationsTokenTokenValidateQuery, useGetConsumerApplicationsV2CreditApplicationsStatusStatusQuery, useLazyGetConsumerApplicationsV2CreditApplicationsStatusStatusQuery, usePostConsumerApplicationsV2CreditApplicationsApplicationIdIdentityVerificationMutation, useGetConsumerApplicationsV2CreditApplicationsApplicationIdIdentityVerificationQuery, useLazyGetConsumerApplicationsV2CreditApplicationsApplicationIdIdentityVerificationQuery, usePostConsumerApplicationsV2CreditApplicationsApplicationIdApplyMutation, useGetConsumerApplicationsV2ApproveChargeFlowsTokenQuery, useLazyGetConsumerApplicationsV2ApproveChargeFlowsTokenQuery, usePostConsumerApplicationsV2ApproveChargeFlowsApproveChargeFlowIdAcceptMutation, useGetConsumerApplicationsV2AccountFinderLookupVerificationTokenQuery, useLazyGetConsumerApplicationsV2AccountFinderLookupVerificationTokenQuery, usePostConsumerApplicationsV2OtpSendMutation, usePostConsumerApplicationsV2OtpVerifyMutation, useGetConsumerApplicationsV2OtpBypassOtpQuery, useLazyGetConsumerApplicationsV2OtpBypassOtpQuery, useGetConsumerApplicationsV2TransactionsLookupVerificationTokenQuery, useLazyGetConsumerApplicationsV2TransactionsLookupVerificationTokenQuery, usePostConsumerApplicationsV2TransactionsSaleVerificationTokenMutation, useGetConsumerApplicationsV2PlansVerificationTokenQuery, useLazyGetConsumerApplicationsV2PlansVerificationTokenQuery, useGetConsumerApplicationsV2FeatureFlagsGlobalQuery, useLazyGetConsumerApplicationsV2FeatureFlagsGlobalQuery, } = injectedRtkApi;
